export default __webpack_public_path__ + "static/media/MontserratAlternates-SemiBold.7dbc88eb.ttf";